module.exports = __webpack_public_path__ + "img/memphis-01.7537751c.png";